import {guardSportsWatch} from "@/app/routes/guards/sports-guard";

const NAME = 'Виды спорта'

export const sports = [
    {
        path: 'sports',
        loadComponent: () => import('@components/guides/sports/sports.component').then(c => c.SportsComponent),
        canActivate: [guardSportsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'sports/:id',
        loadComponent: () => import('@components/guides/sports/sports-details/sports-details.component').then(c => c.SportsDetailsComponent),
        canActivate: [guardSportsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/sports/'},
            ]
        }
    },
]
